<template>
  <div class="w-100 row m-3 second_section" v-if="is_load">
    <div class="col-12">
      <ul class="nav justify-content-center widget_nav">
        <li class="nav-item" v-if="block.isuser==true || block.isdeveloper==true">
          <a class="nav-link" :class="{'active':type=='projects'}" @click="changeType('projects')"  href="javascript:void(0)">Мои проекты</a>
        </li>
        <li class="nav-item" v-if="(block.isuser==true || block.isdeveloper==true) && block.user_data.tasks.length>0">
          <a class="nav-link" :class="{'active':type=='tasks'}" @click="changeType('tasks')" href="javascript:void(0)">Мои задачи</a>
        </li>
        <li class="nav-item" v-if="block.isdeveloper==true">
          <a class="nav-link" :class="{'active':type=='requests'}" @click="changeType('requests')" href="javascript:void(0)">Заявки на оценку</a>
        </li>

        <li class="nav-item" v-if="block.isshop==true">
          <a class="nav-link"  :class="{'active':type=='shop'}" @click="changeType('shop')"  href="javascript:void(0)">Мой магазин</a>
        </li>
        <li class="nav-item" v-if="block.ismanager==true">
          <a class="nav-link"  :class="{'active':type=='leads'}" @click="changeType('leads')"  href="javascript:void(0)">Сделки</a>
        </li>
        <li class="nav-item" v-if="block.isinvoice==true">
          <a class="nav-link" :class="{'active':type=='invoices'}"  @click="changeType('invoices')" href="javascript:void(0)">Мои счета</a>
        </li>
      </ul>
    </div>

    <div class="col-12" v-if="type=='requests' && block.isdeveloper==true">
      <div class="mobile_div d-flex justify-content-center" v-if="block.developer_data.requests.length==0" >
        <h2 >Заявок на оценку не найдено</h2>
      </div>
      <ProjectCard class="inner_div_block" :project="project" v-if="block.developer_data.requests.length>0"
          v-for="(project,project_index) in block.developer_data.requests" :key="project.last_id"/>

      <div class="section_header row mobile_div    d-flex justify-content-center " v-if="block.developer_data.requests.length>0" >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center">
          <router-link tag="a" class="btn mt-2" :to="{name: 'freelance_tasks'}">
            показать<br> все
          </router-link>
        </div>


      </div>
    </div>
    <div class="col-12" v-if="type=='invoices' && block.isinvoice==true">
      <div class="mobile_div d-flex  justify-content-center" v-if="block.invoice_data.invoices.length==0">
        <h2 >Счетов не найдено</h2>
      </div>
      <div class="second_section mobile_div pt-2 pb-2 mt-2 mb-2"
          v-if="block.invoice_data.invoices.length>0"
          v-for="(invoice,invoice_index) in block.invoice_data.invoices" :key="invoice.invoice_id">
        <div class="row m-4 invoice_block" v-if="invoice.client_id==block.invoice_data.user_id">
          <div class="col-lg-3">
            <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                class="mb-3 btn">
              {{ invoice.last_id }}
            </router-link>
            <br>
            <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                class="mb-3  mt-2 btn">
              открыть
            </router-link>
          </div>
          <div class="col-lg-2">
            <p>{{ invoice.created_at}}</p>
          </div>

          <div class="col-lg-4">
            <div v-if="!(invoice.order && invoice.order.status)">
              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 " pill type="danger">Необходимо оплатить
              </badge>
              <badge v-if="invoice.client_pay==1 && invoice.ispay==0" pill type="danger">Ожидаем<br>подтверждение
              </badge>
              <badge v-if="invoice.ispay==1 && !invoice.order" pill type="success">Счет оплачен</badge>
              <badge v-if="invoice.ispay==1 && invoice.order && invoice.order.status && invoice.order.status.title" >{{ invoice.order.status.title}} </badge>
            </div>
            <div v-if="(invoice.order && invoice.order.status)">
              <badge   pill type="warning">{{ invoice.order.status.title }}</badge>
              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 && invoice.order.status.is_wait==0 " pill type="danger">Необходимо оплатить
              </badge>
              <badge v-if="invoice.ispay==1" pill type="success">Счет оплачен</badge>
            </div>
            <div v-if="(invoice.type && (invoice.type=='every_month' || invoice.type=='every_year'))">
              <badge   pill type="info" v-if="invoice.type=='every_month'">каждый месяц</badge>
              <badge   pill type="info" v-if="invoice.type=='every_year'">каждый месяц</badge>
            </div>

          </div>
          <div class="col-lg-3">


            <p>{{ invoice.sum }} <i>{{ invoice.currency}}</i></p>
          </div>
        </div>

        <div class="row m-4 invoice_block" v-if="invoice.developer_id==block.invoice_data.user_id">
          <div class="col-lg-3">
            <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                class="mb-3  btn">
              #{{
                invoice.last_id
              }}
            </router-link>
            <br>
            <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
                class="mb-3 mt-2 ml-1 mb-sm-0 btn">
              открыть
            </router-link>
          </div>
          <div class="col-lg-2">
            <p>{{ invoice.created_at}}</p>
          </div>

          <div class="col-lg-4">

            <div v-if="!(invoice.order && invoice.order.status)">


              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 " pill type="info">Ждем денег</badge>
              <badge v-if="invoice.client_pay==1 && invoice.ispay==0" pill type="primary">Клиент отправил денег
              </badge>
              <badge v-if="invoice.ispay==1 && !invoice.order" pill type="success">Счет оплачен</badge>
              <badge v-if="invoice.ispay==1 &&invoice.order && invoice.order.status && invoice.order.status.title" >{{ invoice.order.status.title}} </badge>
            </div>
            <div v-if="(invoice.order && invoice.order.status && invoice.order.status.is_wait==0)">
              <badge   pill type="warning">{{ invoice.order.status.title }}</badge>
              <badge v-if="invoice.ispay==1" pill type="success">Счет оплачен</badge>
              <badge v-if="invoice.client_pay==0 && invoice.ispay==0 && invoice.order.status.is_wait==0" pill type="info">Ждем денег</badge>
            </div>
            <div v-if="(invoice.type && (invoice.type=='every_month' || invoice.type=='every_year'))">
              <badge   pill type="info" v-if="invoice.type=='every_month'">каждый месяц</badge>
              <badge   pill type="info" v-if="invoice.type=='every_year'">каждый месяц</badge>
            </div>
            <badge v-if="(invoice.order && invoice.order.status && invoice.order.status.is_wait==1)"   pill type="warning">ожидает вашего<br>подтверждения</badge>
          </div>
          <div class="col-lg-3">
            <p>{{ invoice.sum }} <i>{{ invoice.currency }}</i></p>
          </div>
        </div>
      </div>
      <div class="section_header row mobile_div    d-flex justify-content-center " v-if="block.invoice_data.invoices.length>0" >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center">
          <router-link tag="a" class="btn mt-2" :to="{name: 'invoices'}">
            показать<br> все
          </router-link>
        </div>


      </div>
    </div>
    <div class="col-12" v-if="type=='tasks' && (block.isuser==true || block.isdeveloper==true)">
      <div class="mobile_div d-flex  justify-content-center" v-if="block.user_data.tasks.length==0">
        <h2 >Задач не найдено</h2>
      </div>
      <ProjectCard class="inner_div_block" :project="project" v-if="block.user_data.tasks.length>0"
          v-for="(project,project_index) in block.user_data.tasks" :key="project.last_id"/>

      <div class="section_header row mobile_div    d-flex justify-content-center " v-if="block.user_data.tasks.length>0" >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center">
          <router-link tag="a" class="btn mt-2" :to="{name: 'home',query:{'type':'tasks'}}">
            показать<br> все
          </router-link>
        </div>


      </div>
    </div>
    <div class="col-12" v-if="type=='leads' && block.ismanager==true">
      <div class="d-flex justify-content-center">
      <div class="live__scroll m-0 container mobile_div row section_header  mt-2 mb-2" v-if="block.manager_data['funnels'].length>0">
        <div class="col-sm-4 mt-2 mb-2"  v-for="(funnel,funnel_key) in block.manager_data['funnels']">
          <router-link tag="a" class="btn " :to="{name: 'funnel', params: { id: funnel.last_id }}">
            {{ funnel.title}}
          </router-link>
        </div>
      </div>
      </div>
      <div class="section_header row mobile_div    d-flex justify-content-center " >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center" >
          <router-link tag="a" class="btn btn-sm mt-2" :to="{name: 'add_lead'}">
            добавить <br/>сделку <i class="fa fa-plus-circle"></i>
          </router-link>
        </div>




      </div>
      <div class="mobile_div d-flex  justify-content-center" v-if="block.manager_data.leads.length==0">
        <h2 >Сделок не найдено</h2>
      </div>
      <div class="card mt-2 section_gray_bg lead_card"  v-if="block.manager_data.leads.length>0 " v-for="(lead,lead_key) in block.manager_data.leads">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="card-title">ID Лида:  #{{lead.id}}</h5>
            <h6 class="card-subtitle mb-2 text-muted">Дата добавления: {{ lead.created_at}}</h6>
            <h6 class="card-subtitle mb-2 text-muted">Дата обновления: {{ lead.updated_at}}</h6>
            <p class="card-text">Воронка:<router-link tag="a" :to="{name: 'funnel', params: { id: lead.funnel.last_id }}">
              {{ lead.funnel.title}}
            </router-link></p>
            <p class="card-text">Статус: {{ lead.status.title }}</p>
            <p class="card-text"  v-if="lead.tags && lead.tags.length>0"
            >Теги:<b v-for="(tag,tag_index) in lead.tags" :key="tag_index">
              #<router-link tag="a" :to="{name: 'leads', query: { q: tag }}">
              {{tag}}
            </router-link>&nbsp;</b>
            </p>
          </div>

          <div class="col-sm-6">
            <h5 class="card-title">Информация о лиде:</h5>
            <p class="card-text" v-if=" lead.lead_data[c_field.name]" v-for="c_field in block.manager_data.fields"><i class="fa fa-phone-square " v-if="c_field.type=='phone'"></i> <i class="fa fa-vk" v-if="c_field.type=='vk'"></i> <i class="fa fa-address-book-o" v-if="c_field.type=='email'"></i> {{ c_field.title}}: <a v-if="c_field.type=='vk'" target="_blank" :href="lead.lead_data[c_field.name]" >{{ lead.lead_data[c_field.name] }}</a> <b v-if="c_field.type!='vk'">{{ lead.lead_data[c_field.name] }}</b></p>

            <router-link tag="a"  :to="{name: 'lead', params: { id: lead.id }}">
              Открыть сделку
            </router-link>
          </div>
        </div>


      </div>

      <div class="section_header row mobile_div    d-flex justify-content-center " v-if="block.manager_data.leads.length>0" >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center">
          <router-link tag="a" class="btn mt-2" :to="{name: 'leads'}">
            показать<br> все
          </router-link>
        </div>


      </div>


    </div>
    <div class="col-12" v-if="type=='projects' && (block.isuser==true || block.isdeveloper==true) ">
      <div class="section_header row mobile_div    d-flex justify-content-center " >

        <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-center" v-if="block.isdeveloper==true">
          <router-link tag="a" class="btn btn-sm mt-2" :to="{name: 'add_project'}">
            Создать <br/>проект <i class="fa fa-plus-circle"></i>
          </router-link>
        </div>
        <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-center" v-if="block.iscanfreelance==true">
          <router-link tag="a" class="btn btn-sm mt-2" :to="{name: 'freelance_new_request'}">
            заказать<br> услугу <i class="fa fa-dollar"></i>
          </router-link>
        </div>


      </div>
      <div class="mobile_div d-flex  justify-content-center" v-if="block.user_data.projects.length==0">
        <h2 >Проектов не найдено</h2>
      </div>
      <ProjectCard :project="project" class="inner_div_block" v-if="block.user_data.projects.length>0"
          v-for="(project,project_index) in block.user_data.projects" :key="project.last_id"/>

      <div class="section_header row mobile_div    d-flex justify-content-center " v-if="block.user_data.projects.length>0" >

        <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-center">
          <router-link tag="a" class="btn mt-2" :to="{name: 'home'}">
            показать<br> все
          </router-link>
        </div>


      </div>
    </div>
    <div class="col-12" v-if="type=='shop' && block.isshop==true">
      <div class="row justify-content-center">

        <div class="d-flex justify-content-center col-12 col-md-6 col-lg-6">

          <div class="second_section mt-2 mb-2">




            <p class="d-flex justify-content-center" v-if="ismanual==true"><router-link class="btn m-2" to="/withdrawal" >Вывод средств
            </router-link></p>


            <p class="d-flex justify-content-center" v-if="user.isshop==1" ><router-link class="btn m-2"  to="/setup/shop?tab_active=setting" >Настройка магазина</router-link></p>
            <p class="d-flex justify-content-center" v-if="user.isshop==1" ><router-link class="btn m-2"  to="/setup/shop?tab_active=items" >Управление Товарами</router-link></p>




          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCard from "@/components/Custom/ProjectCard";
import Vue from "vue";
import UserModel from "@/models/UserModel";
import Api from "@/models/Api";

export default {
  name: "LkWidget",
  components:{ProjectCard},
  data(){
    return {
      'is_load':false,
      'type':'',
      "type_currencys":[],
      "currencys_title":[],
      "ismanual":false,
      "user":null,
    };
  },
  props: {
    block: Object,
    first_tab:String,
  },
  mounted(){
    var app=this;
    app.type=app.first_tab;

    app.getUserData();
  },
  methods:{
    changeType(type){
     this.type=type;
    },
    async getUserData(){
      var app=this;
      var user_data=await UserModel.getWithUpdate();
      app.user=user_data;
      if(app.user && app.user.last_id){

        app.is_load=true;

      }
      Api.loadWithdrawalStatus(function(data){
        app.ismanual=data.ismanual;
      },function(){

      });

    },
  }
}
</script>

<style scoped>

</style>